import React from "react";
import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import SectionTitle from "./SectionTitle";
import ProjectImagesCarousel, {
  MAX_HOME_PROJECT_IMAGES,
  projectImageSkeletonCompactClass,
} from "./ProjectImagesCarousel";
import { useSiteAboutData } from "../hooks/useSiteData";

const DEFAULT_SECTION = {
  tagline: "Our Portfolio",
  title: "Engineering India's Landmark Projects",
  subtitle:
    "From power plants and refineries to metro systems and hydro projects — every assignment delivered with precision and uncompromising quality.",
};

export default function ProjectsPreview() {
  const { data: about, isLoading: loading } = useSiteAboutData();

  const projectImages = about?.projectImageUrls || [];
  const sectionTitle = DEFAULT_SECTION.title;

  if (!loading && projectImages.length === 0) return null;

  return (
    <section className="relative overflow-hidden py-20 md:py-24">
      <div className="pointer-events-none absolute inset-0 bg-gradient-to-b from-white via-slate-50/50 to-white" />
      <div className="pointer-events-none absolute -right-20 top-10 h-64 w-64 rounded-full bg-[#1e6fcf]/6 blur-3xl" />

      <div className="relative mx-auto max-w-7xl px-4 sm:px-6">
        <div className="mb-8 flex flex-col justify-between gap-6 lg:mb-10 lg:flex-row lg:items-end">
          <SectionTitle
            eyebrow={DEFAULT_SECTION.tagline}
            title={sectionTitle}
            subtitle={DEFAULT_SECTION.subtitle}
          />
          <Link
            to="/projects"
            className="inline-flex items-center gap-2 self-start rounded-lg border border-slate-200 bg-white px-5 py-3 text-sm font-bold text-[#0a1a2f] shadow-sm transition-all duration-300 hover:border-[#1e6fcf] hover:bg-[#1e6fcf] hover:text-white lg:self-auto"
          >
            All Projects
            <ArrowUpRight className="h-4 w-4" />
          </Link>
        </div>

        {loading ? (
          <div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
            {[1, 2, 3, 4].map((n) => (
              <div key={n} className={projectImageSkeletonCompactClass} />
            ))}
          </div>
        ) : (
          <ProjectImagesCarousel
            images={projectImages}
            limit={MAX_HOME_PROJECT_IMAGES}
            carouselKey="home-project-images"
            enableLightbox
            lightboxTitle={sectionTitle}
            compact
          />
        )}
      </div>
    </section>
  );
}
